module.exports = __webpack_public_path__ + "static/img/logo05.de6e73e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo05.jpg
// module id = OWa4
// module chunks = 1